import { eligibilityCriteriaApi, expressionDefinitionApiV2 } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const ELIGIBILITY_CRITERIA_ACTION_TYPE = createNamedActions('eligibilityCriteria', {
  GET_ELIGIBILITY_CRITERIA: 'GET_ELIGIBILITY_CRITERIA',
  GET_ELIGIBILITY_CRITERIA_SCHEMA: 'GET_ELIGIBILITY_CRITERIA_SCHEMA',
  CREATE_ELIGIBILITY_CRITERIA: 'CREATE_ELIGIBILITY_CRITERIA',
  EDIT_ELIGIBILITY_CRITERIA: 'EDIT_ELIGIBILITY_CRITERIA',
  DELETE_ELIGIBILITY_CRITERIA: 'DELETE_ELIGIBILITY_CRITERIA',
});

const criteria = new schema.Entity('criteria', {}, { idAttribute: 'criteriaId' });

export const getEligibilityCriteriaAction = catchAsyncActionError(
  ({ snapshotId }) =>
    async dispatch => {
      const { data } = await eligibilityCriteriaApi.getEligibilityCriteria({ snapshotId });

      return dispatch({
        type: ELIGIBILITY_CRITERIA_ACTION_TYPE.GET_ELIGIBILITY_CRITERIA,
        payload: normalize(data, [criteria]).entities.criteria,
      });
    },
);

export const createEligibilityCriteriaAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await eligibilityCriteriaApi.createEligibilityCriteria(params);

  return dispatch({
    type: ELIGIBILITY_CRITERIA_ACTION_TYPE.CREATE_ELIGIBILITY_CRITERIA,
    payload: data,
  });
});

export const editEligibilityCriteriaAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await eligibilityCriteriaApi.editEligibilityCriteria(params);

  return dispatch({
    type: ELIGIBILITY_CRITERIA_ACTION_TYPE.EDIT_ELIGIBILITY_CRITERIA,
    payload: data,
  });
});

export const deleteEligibilityCriteriaAction = catchAsyncActionError(params => async dispatch => {
  await eligibilityCriteriaApi.deleteEligibilityCriteria(params);

  return dispatch({
    type: ELIGIBILITY_CRITERIA_ACTION_TYPE.DELETE_ELIGIBILITY_CRITERIA,
    meta: params,
  });
});

export const getEligibilitySchemaParamsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await expressionDefinitionApiV2.getEligibilityCriteriaExpressionDefinition();

  return dispatch({
    type: ELIGIBILITY_CRITERIA_ACTION_TYPE.GET_ELIGIBILITY_CRITERIA_SCHEMA,
    payload: data,
  });
});
